import React, { Component } from 'react';
import AiOption from "./AiOption";
import AiReviewWrap from './AiReviewWrap';
import { SPECIAL_NOTE_SMALL, SPECIAL_NOTE_SMALL2 } from '../constants';
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';
import smoothscroll from 'smoothscroll-polyfill';
window.__forceSmoothScrollPolyfill__ = true;
smoothscroll.polyfill();

var accTab = '1'
var orientation = ''

export function scrollToOption(option) {
  let id = option.length === 2 ? '1' : '2'

  if (orientation !== 'portrait' && accTab !== id) {
    accTab = id;
    document.getElementById('accordion__heading-'+id).click();
  }

  var element = document.getElementById(option);
  var rect = element.getBoundingClientRect();
  var windowHeight = (window.innerHeight || document.documentElement.clientHeight);
  var offset = parseInt(rect.height, 10) / 2 - windowHeight / 2;
  if (orientation === 'portrait')
    offset -= 295/2;
  var top = 0;
  
  do {
      top += parseInt(element.offsetTop, 10) || 0;
      element = element.offsetParent;
  } while(element);

  let y = top + offset;
  if ((getLowerBound() < y) || ((getLowerBound() - y) <= 15))
    y = getLowerBound();

  /* console.log('default', 'window.scrollTo(0, ' + (top + offset).toFixed(0) + ');')
  console.log('bounds', 'window.scrollTo(0, ' + getLowerBound().toFixed(0) + ');') */
  
  window.scrollTo({ top: y.toFixed(0), left: 0, behavior: 'smooth'});
}

function getLowerBound() {
  var element;
  var offset;
  if (orientation !== 'portrait') {
    element = document.querySelector('.ai-right-panel')
    offset = 5;
  }
  else {
    element = document.querySelector('.ai-main-body')
    offset = 15;
  }

  var rect = element.getBoundingClientRect();
  var windowHeight = (window.innerHeight || document.documentElement.clientHeight);
  var top = 0;

  do {
      top += parseInt(element.offsetTop, 10) || 0;
      element = element.offsetParent;
  } while(element);
  
  return top + parseInt(rect.height, 10) - windowHeight + offset;
}

function checkViewport(id) {
  /* if (accTab === id)
    return
  else */
    accTab = id
  /* if (id === '1') {
    var element = document.getElementById('ai-panel');
    var offset = 5;
  }
  else {
    var element = document.getElementById('header' + (id - 1));
    var offset = (id - 1) * 42.5;
  } */
  var element = document.getElementById('ai-panel');
  var offset = 5;
  const rect = element.getBoundingClientRect();

  if (!(rect.top - offset >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth))) {
    var top = 0, left = 0;
    do {
        top += element.offsetTop  || 0;
        left += element.offsetLeft || 0;
        element = element.offsetParent;
    } while(element);
    window.scrollTo({ top: top - offset, left: left, behavior: 'smooth'});
  }
}

class AiOptionSet extends Component {
  constructor(props) {
      super(props);
      orientation = this.props.orientation;
      accTab = '1';
  }
  componentDidUpdate() {
    if (this.props.type === '0') {
      if (accTab !== '1') {
        accTab = '1';
        document.getElementById('accordion__heading-1').click();
      }
    }
    if (orientation !== this.props.orientation && this.props.orientation !== undefined) {
      orientation = this.props.orientation;
      if (accTab !== '1') {
        accTab = '1';
        document.getElementById('accordion__heading-1').click();
      }
    }
  }
  render() {
    var fullAccordion = (this.props.orientation !== 'portrait')
    var splashScreen = (this.props.type === '0')
    var combined
    var rows = [];
    var cross = [];//<div key="separator" className="separator">&nbsp;ADD MATCHING STYLE&nbsp;</div>
    var review = this.props.initial===''?<AiReviewWrap/>:''
    let headercolor ='ai-review-header ai-review-' + window.currentSite
    //var review = this.props.initial!==''?'':(fullAccordion?<AiReviewWrap/>:<Accordion onTabOpen={this.props.onOpenReview} ><AccordionTab header="REVIEW"   headerClassName={headercolor}  icon="pi pi-plus" ><AiReviewWrap/></AccordionTab> </Accordion>)
    var patent = this.props.initial===''?<div key="patent" className="separator2">&nbsp;Patent Pending Technology&nbsp;</div>:''
    var last = 0 
    var cur_option

    if (this.props.options['options_all'] !== undefined) {
      last = this.props.options['options_all'].length -1
    }  
    for (let i in this.props.options['options_all']) {
      cur_option= this.props.options['options_all'][i]
      //console.log('last value',cur_option,parseInt(i,10),last, this.props.single_sc_option)
      var lastValue ='false'
      if (parseInt(i,10)===last || (cur_option === "sc" && this.props.single_sc_option )) {
        lastValue = 'true' 
        //console.log('let lastValue be TRUE')
      } 

      var cur_details= this.props.options['options_' + cur_option]
      //console.log('cur_option',cur_option,this.props.options)
      var cur_name = cur_details.name
      if (cur_details.option_name === 'stone') {
        cur_name = "Stone"
        
      }
      var cur_value = this.props.options['value_' + cur_option]
      
      var red_note =SPECIAL_NOTE_SMALL
      var red_note2 =SPECIAL_NOTE_SMALL2
      //var red_note ='' 
      //var red_note1=''
      //var red_note2=''
      //var red_link=''

      /*if (this.props.site === 'kay'){
        red_note1 =SPECIAL_NOTE_SMALL1
        red_note2 =SPECIAL_NOTE_SMALL2
        red_link =<a href={SPECIAL_NOTE_LINK}>click here</a> 
      }*/
      var option_name =
       this.props.options['options_' + cur_option].option_name !== undefined ? ' ai-name-'+this.props.options['options_' + cur_option].option_name: ''
    //  console.log('this.props.option_name',option_name,this.props,cur_details)
    var maxSliderSize = (this.props.optionNumber * this.props.optionSize + 60) +'px';
    //var maxSliderSizeNum = this.props.optionNumber * this.props.optionSize 
      if (cur_details.show)
       switch (cur_details.type) {
      
        case 'select':
        case 'control':
          //console.log('AIOptions',this.props)
          if (["cross1", "rs2", "cross2", "cross3", "bl2"].includes(cur_option)) {
            var cssep = (((this.props.type === 'B' && cur_option === 'cross3') || (cur_option === 'bl2' || (cur_option === 'cross3' && this.props.cross3 === '0'))) && !fullAccordion)?' cross-sep':''
    
            cross.push(<AiOption
              cssep={cssep}
              key={cur_option} 
              name={cur_name} 
              attr={cur_option} 
              css={cur_details.css}
              dict={this.props.dict}
              ds ={this.props.ds}
              dctw ={this.props.dctw}
              head ={this.props.head}
              hmet ={this.props.hmet}
              rmet ={this.props.rmet}
              cec = {this.props.cec}
              cec2 = {this.props.cec2}
              headc ={this.props.headc}
              rsetc ={this.props.rsetc}
              rs={this.props.rs}
              bl={this.props.bl}
              sh ={this.props.sh}
              inisku = {this.props.inisku}
              sku = {this.props.sku}
              store={this.props.store}
              type={this.props.type}
              children={cur_details.options} 
              optionNumber={this.props.optionNumber}
              imageSize={this.props.imageSize}
              optionSize={this.props.optionSize}
              optionName={option_name}
              orientation={this.props.orientation}
              initialValue={cur_value}
              image_base={cur_details.image_base}
              image_postfix={cur_details.image_postfix}
              last= {lastValue}
              options_all={this.props.options_all}
              />);
          }
          else if (cur_option !== 'rmet' || (cur_option === 'rmet' && this.props.hmet !== 'S')) {
           rows.push(<AiOption 
            cssep={''}
            key={cur_option} 
            name={cur_name} 
            attr={cur_option} 
            css={cur_details.css}
            dict={this.props.dict}
            ds ={this.props.ds}
            dctw ={this.props.dctw}
            head ={this.props.head}
            hmet ={this.props.hmet}
            rmet ={this.props.rmet}
            cec = {this.props.cec}
            cec2 = {this.props.cec2}
            headc ={this.props.headc}
            rsetc ={this.props.rsetc}
            rs={this.props.rs}
            bl={this.props.bl}
            sh ={this.props.sh}
            inisku = {this.props.inisku}
            sku = {this.props.sku}
            store={this.props.store}
            type={this.props.type}
            children={cur_details.options} 
            optionNumber={this.props.optionNumber}
            imageSize={this.props.imageSize} 
            optionSize={this.props.optionSize}
            optionName={option_name}
            orientation={this.props.orientation}
            initialValue={cur_value}
            image_base={cur_details.image_base}
            image_postfix={cur_details.image_postfix}
            last= {lastValue}
            options_all={this.props.options_all}
            />);
           }
            /* if (this.props.type === 'B') {
              if (cur_option === 'cross3'){
                rows.push(<br key="br1"></br>)
                rows.push(<br key="br2"></br>)
                rows.push(patent)
              }
            }           
            else {
              if (cur_option === 'bl2' || (cur_option === 'cross3' && this.props.csopt[2] === '0')){
                rows.push(<br key="br1"></br>)
                rows.push(<br key="br2"></br>)
                rows.push(patent)
              }
            } */
           
              break;
        default:
            break;
        
      }
      
    }
    var inithelp=''
    var separate =<div key="separator" className={"separator" + (splashScreen ? ' hideStart' : '')}>&nbsp;ADD MATCHING STYLE&nbsp;</div>
    if (window.testAB==='C' && this.props.initial ==='yes') 
//            rows.push(<div  key="text1" className='ai-text1'><b>{l1}</b><br/><br/>{l2}<br/>{l3}<br/>{l4}<br/>  </div>)
{
     inithelp =<div><hr className="ai-hr" /> <div  key="text1" className="ai-splashinit" ><img alt='help' width="100%" src='//static.thepersonalizedbest.com/gfr/fjc-help.jpg'   />  </div></div>
     separate=''
     cross=''
  //   rows.push(<div key="start-init" className="ai-AddCharm2wrap ai-button-select" >
  //   <Button  key="add-charm" className="ai-AddCharm2 ai-button-select"   value="init" onClick={(e)=>this.props.onInit(e.currentTarget.value)} label="Start Customize"></Button></div>)
}
    if (fullAccordion) {
      combined = <div className={'ai-option-wrap'} style={{width:maxSliderSize}}>{rows}{separate}{cross}<br/>
          <Accordion ref={this.accordion} preExpanded={['1']} /* onTabOpen={this.props.onOpenReview} */>
            <AccordionItem uuid="1">
              <AccordionItemHeading className={headercolor + (splashScreen ? ' splashScreen' : '')}  icon="pi pi-plus">
                <AccordionItemButton>Product Overview and Details</AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                {review}
              </AccordionItemPanel>
            </AccordionItem>
          </Accordion>{/*<div className='ai-bottom'/>*/}
         

      </div>

      /* combined = <div className='ai-option-wrap' style={{width:maxSliderSize}}>
          <Accordion allowMultipleExpanded={false} preExpanded={'1'} onChange={(e) => {checkViewport(e[0]);}}>
            <AccordionItem uuid="1">
              <AccordionItemHeading id="header1" className={headercolor + (splashScreen ? ' splashScreen' : '')}  icon="pi pi-plus">
                <AccordionItemButton>CUSTOMIZATION</AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel className={(splashScreen && this.props.imageSize === 'big') ? 'splash' : ''}>
                {rows}
              </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem uuid="2">
              <AccordionItemHeading id="header2" className={headercolor + (splashScreen ? ' splashScreen' : '')}  icon="pi pi-plus">
                <AccordionItemButton>MATCHING STYLES</AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                {cross}
              </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem uuid="3">
              <AccordionItemHeading id="header3" className={headercolor + (splashScreen ? ' splashScreen' : '')}  icon="pi pi-plus">
                <AccordionItemButton>REVIEW</AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                {review}
              </AccordionItemPanel>
            </AccordionItem>
          </Accordion>
        <p></p>
       {patent}
      </div> */
    }
    else {
      combined = <div className={'ai-option-wrap' + (splashScreen ? ' hideStart' : '')} style={{width:maxSliderSize}}>{rows}<div key="separator" className={"separator" + (splashScreen ? ' hideStart' : '')}>&nbsp;ADD MATCHING STYLE&nbsp;</div>{cross}<br/>
          <Accordion ref={this.accordion} preExpanded={['1']} /* onTabOpen={this.props.onOpenReview} */>
            <AccordionItem uuid="1">
              <AccordionItemHeading className={headercolor + (splashScreen ? ' splashScreen' : '')}  icon="pi pi-plus">
                <AccordionItemButton>Product Overview and Details</AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                {review}
              </AccordionItemPanel>
            </AccordionItem>
          </Accordion>
          
        
      </div>
    }
    //{/*<div className='ai-bottom'/>*/}
    var addesa=''
    var esaval=''
    var esadetail=[]
    var i
    var addesa2='' 
    var addesa4='' 
    console.log('esa from state',this.props.esa,this.props.price1)    
    if (this.props.esa !== undefined)
    {
    for (i in   this.props.esa) {
      if (parseFloat(this.props.price1) >= this.props.esa[i][0] && parseFloat(this.props.price1) <= this.props.esa[i][1]) {
      //console.log( 'i',this.props.esa[i])
      esaval=this.props.esa[i][2]
      }
    }
    for (i in this.props.esadetail)
    if (this.props.esadetail[i][0] === 'Ring Sizing')
    {
     esadetail.push(<tr><td className="ai-esa-th"><b>{this.props.esadetail[i][0]}<sup>4</sup></b></td><td key={"td1"+i.toString} className="ai-esa-th">{this.props.esadetail[i][1]}</td><td className="ai-esa-th">INCLUDED</td></tr>)
     addesa4=<p id="ringDisc" styleName="ai-esa-padding">
      <sup>4</sup>Allow ring sizing up or down two sizes.
    </p>
    }
     else if (this.props.esadetail[i][0] === 'Free One-Time Engraving'){
     esadetail.push(<tr><td className="ai-esa-th"><b>{this.props.esadetail[i][0]}<sup>2</sup></b></td><td key={"td2"+i.toString}className="ai-esa-th">{this.props.esadetail[i][1]}</td><td className="ai-esa-th">INCLUDED</td></tr>)
     addesa2=<sup>1,2</sup> 
     }
     else 
        esadetail.push(<tr><td className="ai-esa-th"><b>{this.props.esadetail[i][0]}</b></td><td  key={"td3"+i.toString} className="ai-esa-th">{this.props.esadetail[i][1]}</td><td className="ai-esa-th">INCLUDED</td></tr>)
    addesa=
    <div>
    <div className="ai-esa-icon">
              <input type="checkbox" id="addToCartPlanSub"  onClick={(e)=>this.props.onESA(e.currentTarget.checked)}/>
          
              <img className='ai-esa-img' alt='ESA' width='18px' height='18px' src="//static.thepersonalizedbest.com/pers4/esaIcon.svg"></img>
              <div className="ai-chat-text">
                             <p>Protect Your Jewelry For Life<sup>1</sup> for ${esaval}</p>
                             <p className='ai-esa-font'> Enjoy lifetime service with a one-time purchase</p>
              </div> 
      
    </div>
    <div className="ai-esa-block">
    <table className="ai-esa-table">
                   <thead  className={"ai-esa-thead-"+  window.currentSite}>
        <tr>
          <th className="ai-esa-th" key="th1">Service Needed</th>
          <th className="ai-esa-th" key="th2">Typical Cost<sup>5</sup></th>
          <th className="ai-esa-th" key="th3">With This Plan</th>
        </tr>
      </thead><tbody>
      {esadetail}
      </tbody>
                   </table>
        
    </div>
    <div className="ai-esa-th">
  <a href={window.baseSiteUrl+"/lifetime-protection-plan"}  target="_blank">Learn more</a>
  </div>
  
  <span className="ai-esa-discl">
  <div className="ai-esa-padding">
    <sup>1</sup>
      Excludes repair and replacement of diamonds and gemstones. 
    
      {addesa2}
      Other limitations apply. By purchasing, I agree to&nbsp;
    <u>
      <a target="_blank" href={window.baseSiteUrl+"/lifetime-protection-plan-details"}>Plan Terms and Electronic Delivery.</a>
    </u>
    {addesa4}
    <p id="costDisc" className="ai-esa-padding">
      <sup>5</sup>Costs may vary depending on specific service, size and material type.
    </p>
  </div></span>
    </div>
    }
    
    var addchat=''
    
          if (this.props.initial !=='yes')
              addchat= 
              <div className="ai-chat-block">
              <div className="ai-chat-icon">
                                     <img alt='chat' width='45px' height='45px' src="//static.thepersonalizedbest.com/pers4/chat.jpg"></img>
              </div>
              <div className="ai-chat-text">
                             <p>Have a question about {this.props.title}?</p>
                             <p><a href="javascript:document.getElementsByClassName('LPMcontainer')[0].click();" >Chat Now</a></p>
              </div>
              </div> 
    return (
      <div className='ai-option-wrap' style={{width:maxSliderSize}}>
      {combined}
      {inithelp}<br/>
      <div className={'ai-special-note ai-special-note2' + (splashScreen ? ' hideStart' : '')}><font color='red'>{red_note}<br></br>{red_note2}</font></div>
      <p></p>
      {addesa}
      {addchat}<br/>
      {patent}<br/>
      </div>
             
    );
  }
}
export default AiOptionSet;


// WEBPACK FOOTER //
// ./src/layout/AiOptionSet.js